import * as React from 'react';
import {
    TextInput, SelectInput, PasswordInput,
    SimpleForm,
    useRecordContext, useGetIdentity
} from 'react-admin';
import { Box } from '@mui/material';
import { roleChoices, validateForm } from './utils';
import SectionTitle from '../commons/SectionTitle';

export const UserForm = ({ passwordRequired }) => {
    const { identity, isLoading: identityLoading } = useGetIdentity();
    return (
        <SimpleForm sx={{ maxWidth: 500 }} validate={validateForm(passwordRequired)}>

            <SectionTitle label="Identity" />
            <Box display={{ xs: 'block', sm: 'flex', width: '100%' }}>
                <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
                    <TextInput source="name" isRequired fullWidth />
                </Box>
                <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                    <SelectInput source="role" choices={
                        !identityLoading && identity.isRoot && identity.role == "admin" ? roleChoices : roleChoices.slice(0, 1)
                        } isRequired fullWidth disabled={identityLoading} 
                    />
                </Box>
            </Box>
            <TextInput type="email" source="email" isRequired fullWidth />

            <Box pt="1em" />
            <SectionTitle label="Password" />
            <Box display={{ xs: 'block', sm: 'flex' }}>
                <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
                    <PasswordInput source="password" fullWidth />
                </Box>
                <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                    <PasswordInput source="confirm_password" fullWidth />
                </Box>
            </Box>

        </SimpleForm >
    )
};

export const UserTitle = () => {
    const record = useRecordContext();
    if (record) {
        const roleName = roleChoices.find(item => item.id == record.role).name;
        const userName = record.name;
        return <span>{`${roleName} "${userName}"`}</span>;
    } else {
        return <span>{'User "Unknow"'}</span>;
    }
};
